import React, {Component} from 'react';

import Workflow from "../core/Workflow";
import axios from "axios";
import AuthService from "../../AuthService";


class Observation extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();

        this.state = {
            workflowInitData : {
                WORKFLOW_ID: 6,
                PARAM_observationId: this.props.match.params.observationId,
                PARAM_utilisateurId: 1, // TODO récupérer l'ID du localStorage stocké à partir du token
            },
            observationId: this.props.match.params.observationId,
        }
        
        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    coreChange(e) {
        if (e.target.name === "BLOCK_ITEM_3010101" && !(this.state.observationId) && !!(e.target.value)) {
            document.location = "/admin/observation/" + e.target.value;
        }
    }

    async coreExternalCall(method) {
    	if (method === "delete") {
        	await axios.post(AuthService.getUrl('/deleteObservation'), {id: this.state.observationId}, AuthService.getAuthHeader()).then(
                res => {
                    this.props.history.push('/admin/observations');
                }
            );
        }
        if (method === "leave") {
            this.props.history.push('/admin/observations');
        }
    }

    coreSubmit(data) {
        if (!!data) {
            data.screen.blocks[0].blockItems.map(blockItem => {
                if (blockItem.id === 300001) {
                    this.state.observationId = blockItem.values[0];
                }
            });
        }
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                    <div className="errorMessage">
                        <span>{this.state.errorMessage}</span>
                    </div>
                }
                {!!(this.state.validMessage) &&
                    <div className="actionMessage">
                        <span>{this.state.validMessage}</span>
                    </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.observationId}/>
            </div>
        );
    }
}

export default Observation;
